import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = {
  key: 0,
  class: "grid w-full grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-7"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["innerHTML"]

import BookingLayout from '@/layouts/BookingLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import BranchCard from '@/components/cards/BranchCard.vue';
import ComingSoonBranchCard from '@/components/cards/ComingSoonBranchCard.vue';
import PatientInformation from '@/components/cards/PatientInformation.vue';
// import { CheckIcon } from "@heroicons/vue/24/solid";

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import Storage from '@/helpers/storage';

import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';

import booking from "@/classes/Booking";
import { useBookingStore } from '@/store/booking';

// Router Instance

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingPage',
  setup(__props) {

const router = useRouter();

// State Instance
const bookingStoreState = useBookingStore();

// Local Storage Instance
const bookingLocalStorage = new Storage();
const bookingLocalStoragePayload = ref(JSON.parse(bookingLocalStorage.get('bookingPayload')));
const bookingLocalStorageSummary = ref(JSON.parse(bookingLocalStorage.get('bookingSummary')));
const patientDataLocalStorage = ref(JSON.parse(bookingLocalStorage.get('patient')));

// Data
const loader = ref(false);
const showError = ref(false);
const errorMsg = ref(null);
const selectedBranchId = ref();
const branches = ref();
const step = ref(1);
const patientError = ref(false);
// Methods
const fetchBranches = () => {
    loader.value = true;

    booking.getBranches()
        .then((result: any) => {
            loader.value = false;
            branches.value = result.data.response;            
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const fetchDrafts = () => {
    bookingStoreState.bookingPayload = bookingLocalStoragePayload.value || bookingStoreState.bookingPayload;
    bookingStoreState.bookingSummary = bookingLocalStorageSummary.value || bookingStoreState.bookingSummary;
    
    bookingStoreState.bookingPayload.patient_id = patientDataLocalStorage.value.patient_id;
    selectedBranchId.value = bookingStoreState.bookingPayload.branch_id;
}

const saveDrafts = () => {
    bookingLocalStorage.set('bookingPayload', JSON.stringify(bookingStoreState.bookingPayload));
    bookingLocalStorage.set('bookingSummary', JSON.stringify(bookingStoreState.bookingSummary));
}

const selectedBranch = (branchId: any) =>  {
    const filteredBranch = branches.value.find(x => x.id == branchId);

    bookingStoreState.bookingPayload.branch_id = filteredBranch.id;
    bookingStoreState.bookingPayload.branch_name = filteredBranch.name;
    bookingStoreState.bookingPayload.branch_address = filteredBranch.address_line;
    bookingStoreState.bookingSummary.selectedBranch = filteredBranch.name;

    selectedBranchId.value = bookingStoreState.bookingPayload.branch_id;

}

const selectedPatient = (patient: any) => {
    bookingStoreState.bookingSummary.selectedPatient = patient;
    bookingStoreState.bookingPayload.is_dependent = patient.selected === 'me'? false : true ;
    bookingStoreState.bookingPayload.dependent = patient.dependentForm
    bookingStoreState.bookingPayload.dependent_patient = patient.dependentForm
}

const proceed = () => {
    if(selectedBranchId.value) {
        if(step.value === 1){
            saveDrafts();
            step.value++
        } else {
            
            // First check if patient is selected
            if(!bookingStoreState.bookingSummary.selectedPatient?.selected){
                patientError.value = true
                return
            }
            patientError.value = false
            
            // If booking is for a dependent, validate dependent information
            if(bookingStoreState.bookingPayload.is_dependent) {
                const validation = bookingStoreState.validateDependentInfo();
                
                if(!validation.isValid) {
                    // Display error message with validation errors
                    showError.value = true;
                    errorMsg.value = Object.values(validation.errors).join(', <br>');
                    return;
                }
            }
            
            saveDrafts();

            // If all validations pass, proceed to next page
            router.push('/booking/choose-package');
        }
    }
}

onMounted( () => {
    fetchBranches();
    fetchDrafts();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BookingLayout, {
    step: "1",
    selected: selectedBranchId.value,
    onProceed: proceed
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (step.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branches.value, (item, index) => {
                return (_openBlock(), _createBlock(BranchCard, {
                  key: index,
                  item: item,
                  selectedBranchId: selectedBranchId.value,
                  onClick: _withModifiers(($event: any) => (selectedBranch(item.id)), ["prevent"])
                }, null, 8, ["item", "selectedBranchId", "onClick"]))
              }), 128)),
              _createVNode(ComingSoonBranchCard)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(PatientInformation, {
                error: patientError.value,
                patient: _unref(bookingStoreState).bookingSummary.selectedPatient,
                onSelectedPatient: selectedPatient
              }, null, 8, ["error", "patient"])
            ])),
        _createElementVNode("div", {
          class: _normalizeClass(["hidden w-full mt-auto text-right lg:block", step.value > 1 ? 'lg:flex justify-between' : ''])
        }, [
          (step.value === 2)
            ? (_openBlock(), _createBlock(ButtonComponent, {
                key: 0,
                secondary: "",
                "show-icon": false,
                text: "Go Back",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value--))
              }))
            : _createCommentVNode("", true),
          _createVNode(ButtonComponent, {
            disabled: !selectedBranchId.value,
            text: "Continue",
            onClick: _withModifiers(proceed, ["prevent"])
          }, null, 8, ["disabled", "onClick"])
        ], 2)
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createElementVNode("p", { innerHTML: errorMsg.value }, null, 8, _hoisted_4)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["selected"]))
}
}

})